import { useState, useEffect } from "react";
import { type LeadOutreachHistoryEntry } from "../../lib/lead-types.ts";
import { getLeadHistory } from "../../lib/lead-storage.ts";

export function LeadHistorySection() {
  const [history, setHistory] = useState<LeadOutreachHistoryEntry[]>([]);
  const [selectedEntry, setSelectedEntry] = useState<LeadOutreachHistoryEntry | null>(null);

  function refresh() {
    setHistory(getLeadHistory());
  }

  useEffect(() => {
    refresh();
  }, []);

  return (
    <div className="lead-history-space space-y-4">
      <div className="card flex-between">
        <div>
          <h3>Outreach &amp; Follow-Up Sent History</h3>
          <p className="muted text-xs">
            Audit log of manual 1-by-1 outreach emails sent from{" "}
            <span className="mono">mail@currencycore.dev</span> (or{" "}
            <span className="mono">mail@currency-core.com</span>).
          </p>
        </div>
        <button type="button" className="btn btn-secondary btn-sm" onClick={refresh}>
          Refresh History
        </button>
      </div>

      <div className="card table-card">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Recipient / Company</th>
                <th>Subject</th>
                <th>Template</th>
                <th>Sent At</th>
                <th>Status</th>
                <th className="text-right">Action</th>
              </tr>
            </thead>
            <tbody>
              {history.length === 0 ? (
                <tr>
                  <td colSpan={6} className="text-center py-8 muted">
                    No lead outreach emails have been sent yet.
                  </td>
                </tr>
              ) : (
                history.map((entry) => (
                  <tr key={entry.id} className="lead-row">
                    <td>
                      <div className="font-semibold text-white">
                        {entry.companyName || "Lead"}
                      </div>
                      <div className="text-xs mono muted">To: {entry.recipientEmail}</div>
                      {entry.senderEmail && (
                        <div className="text-xs mono text-secondary">
                          From: {entry.senderEmail}
                        </div>
                      )}
                    </td>
                    <td>
                      <div className="text-sm truncate max-w-xs">{entry.subject}</div>
                    </td>
                    <td>
                      <span className="badge badge-neutral text-xs">
                        {entry.templateName}
                      </span>
                    </td>
                    <td className="text-xs muted">
                      {new Date(entry.sentAt).toLocaleString()}
                    </td>
                    <td>
                      {entry.status === "sent" ? (
                        <span className="badge badge-ok">Sent</span>
                      ) : (
                        <span className="badge badge-danger" title={entry.error || "Failed"}>
                          Failed
                        </span>
                      )}
                    </td>
                    <td className="text-right">
                      <button
                        type="button"
                        className="btn btn-ghost btn-xs"
                        onClick={() => setSelectedEntry(entry)}
                      >
                        View Content
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Content View Modal */}
      {selectedEntry && (
        <div className="modal-backdrop" onClick={() => setSelectedEntry(null)}>
          <div
            className="modal-box modal-lg"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-head">
              <div>
                <h3>{selectedEntry.subject}</h3>
                <p className="muted text-xs">
                  Sent to {selectedEntry.recipientEmail} from{" "}
                  {selectedEntry.senderEmail || "mail@currencycore.dev"} (
                  {selectedEntry.companyName}) on{" "}
                  {new Date(selectedEntry.sentAt).toLocaleString()}
                </p>
              </div>
              <button
                type="button"
                className="btn btn-ghost btn-icon"
                onClick={() => setSelectedEntry(null)}
              >
                ✕
              </button>
            </div>
            <div className="modal-body">
              <div className="email-preview-envelope">
                <div
                  className="email-rendered-html prose"
                  dangerouslySetInnerHTML={{ __html: selectedEntry.htmlContent }}
                />
              </div>
            </div>
            <div className="modal-foot">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setSelectedEntry(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
